module.exports = __webpack_public_path__ + "img/mlt_x_845.cb9d7337.jpg";